import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_URL = `${configs.BACKEND_URL}/api/user`;

export async function validateInvitationToken(token) {
  const response = await fetchWithTenant(`${API_URL}/validate-invitation/${token}`);

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to validate invitation');
  }

  return response.json();
}

export async function registerUser({ name, email, password, role, token }) {
  const response = await fetchWithTenant(`${API_URL}/register`, {
    method: 'POST',
    body: JSON.stringify({ name, email, password, role, token }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Registration failed');
  }

  return response.json();
}
